var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-table"},[_c('table',_vm._l((_vm.data),function(datum){return _c('tr',{key:datum.key},[_c('th',[_vm._v(_vm._s(datum.key))]),_c('td',{attrs:{"data-e2e":"show-table"}},[_vm._v(_vm._s(datum.value))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }